import { PolarData } from '../ChartWidgetViewer';
import { PieChartWidgetConfiguration } from '@methodset/application-client-ts';
import { ApexChartUtils } from '../ApexChartsUtils';
import ReactApexChart from 'react-apexcharts';
import classNames from 'classnames';
import './PieChartView.less';

export type PieChartViewProps = {
    className?: string,
    data: PolarData,
    configuration: PieChartWidgetConfiguration
};

export const PieChartView = (props: PieChartViewProps) => {

    const series = (): number[] => {
        const series = props.data.series;
        return series.data.map(entry => entry.y);
    }

    const options = (): ApexCharts.ApexOptions => {
        const options = ApexChartUtils.polarOptions("pie", props.data, props.configuration);
        return options;
    }

    return (
        <div className={classNames('x-piechartview', props.className)}>
            <ReactApexChart
                options={options()}
                series={series()}
                type="pie"
                height={props.configuration.height}
            />
        </div>
    )
}
